import { queryClient, VERSION_CHECK_QUERY_KEY } from "@/app/config/queryClient";

export function triggerVersionCheck(): void {
  void queryClient.invalidateQueries({ queryKey: VERSION_CHECK_QUERY_KEY });
}
